import * as Types from './types.generated';

import * as types from '@src/types';
import { gql } from '@apollo/client';
export type TranslationSetFragment = { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> };

export type MyTranslationSetFragment = { __typename?: 'TranslationSet', uuid: string, myTranslation: string };

export type CoverImageFragment = { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null };

export type ImageUrlsFragment = { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null };

export type MediaFragment = { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null };

export type EnglishOnlyMediaFragment = { __typename?: 'Media', id: number, unoptimizedUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null };

export type EnglishOnlyTranslationSetFragment = { __typename?: 'TranslationSet', uuid: string, en: string, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> };

export type TranslationOverrideFragment = { __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language };

export type CourseTopicFragment = { __typename?: 'Topic', id: number, displayName: string, iconUrl: string, color?: string | null };

export type CourseThinFragment = { __typename?: 'Course', id: number, topic?: { __typename?: 'Topic', id: number, displayName: string, iconUrl: string, color?: string | null } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, org?: { __typename?: 'Org', id: number } | null } };

export type CourseThinNoJoinsFragment = { __typename?: 'Course', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } };

export type LessonFragment = { __typename?: 'Lesson', name: string };

export type CourseFragment = { __typename?: 'Course', id: number, lessonCount: number, publishedAt?: string | null, topic?: { __typename?: 'Topic', id: number, iconUrl: string, displayName: string, color?: string | null } | null, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, createdBy?: { __typename?: 'Employee', id: number, name: string } | null } };

export type CourseInfoFragment = { __typename?: 'Course', id: number, lessonCount: number, publishedAt?: string | null, topic?: { __typename?: 'Topic', id: number, iconUrl: string, displayName: string, color?: string | null } | null, libraryItem: { __typename?: 'LibraryItem', id: string, openedAt?: string | null, publishState?: Types.PublishState | null, archivedAt?: string | null, lastEditedAt?: string | null, createdBy?: { __typename?: 'Employee', id: number, name: string } | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, lastEditedBy?: { __typename?: 'Employee', id: number, name: string } | null } };

export type CourseInstanceFragment = { __typename?: 'CourseInstance', id: number, startedAt?: string | null, dueDate?: string | null, completedAt?: string | null, percentComplete: number, track: number, certificateUrl?: string | null, course: { __typename?: 'Course', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } };

export type EmployeeListItemFragment = { __typename?: 'Employee', id: number, createdAt: string, name: string, firstName: string, lastName: string, email?: string | null, phoneNumber?: string | null, language: Language, hasUsedApp: boolean, deactivatedAt?: string | null, deactivatedReason?: Types.DeactivationReason | null, userType: Types.UserType, lastActivityAt?: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, roles: Array<{ __typename?: 'Role', id: number, name: string }>, deactivatedBy?: { __typename?: 'Employee', id: number, name: string } | null, hrisEmployee?: { __typename?: 'HrisEmployee', id: number, remoteHrisId: string, firstName: string, lastName: string, startDate?: string | null } | null };

export type LocationGroupMemberFragment = { __typename?: 'Employee', id: number, name: string, locations: Array<{ __typename?: 'Location', id: number, name: string }>, roles: Array<{ __typename?: 'Role', id: number, name: string }> };

export type EmployeeThinFragment = { __typename?: 'Employee', id: number, name: string, phoneNumber?: string | null, language: Language, userType: Types.UserType };

export type UserSelectionFragment = { __typename?: 'UserSelection', id: number, allLocations: boolean, allTrainees: boolean, allManagers: boolean, allAdmins: boolean, daysAfterHire?: number | null, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number, user: { __typename?: 'Employee', id: number, name: string } }>, locationMemberships: Array<{ __typename?: 'UserSelectionLocation', id: number, location: { __typename?: 'Location', id: number, name: string } }>, roleMemberships: Array<{ __typename?: 'UserSelectionRole', id: number, role: { __typename?: 'Role', id: number, name: string } }>, locationGroupMemberships: Array<{ __typename?: 'UserSelectionLocationGroup', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }>, roleGroupMemberships: Array<{ __typename?: 'UserSelectionRoleGroup', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }> };

export type BlastSentRecordFragment = { __typename?: 'BlastSentRecord', id: number, firstReadAt?: string | null, messageReaction?: Types.MessageReaction | null, recipient: { __typename?: 'Employee', id: number, name: string, phoneNumber?: string | null, language: Language, userType: Types.UserType }, blastNotifications: Array<{ __typename?: 'BlastNotifications', sentAt: string }> };

export type MessageBlastThinFragment = { __typename?: 'MessageBlast', id: number, createdAt: string, sendAt?: string | null, sentAt?: string | null, recipientCount: number, readCount?: number | null, fromOrg: boolean, fromOpus: boolean, draft: boolean, messageText: { __typename?: 'TranslationSet', uuid: string, en: string }, sentBy: { __typename?: 'Employee', name: string, id: number }, subject?: { __typename?: 'TranslationSet', uuid: string, en: string } | null };

export type CourseInstanceCompleteFragment = { __typename?: 'CourseInstance', id: number, track: number, percentComplete: number, startedAt?: string | null, completedAt?: string | null, accuracy?: number | null, certificateUrl?: string | null, dueDate?: string | null, course: { __typename?: 'Course', enableCertificate: boolean, passingAccuracyThreshold?: number | null, id: number, topic?: { __typename?: 'Topic', id: number, displayName: string, iconUrl: string, color?: string | null } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, org?: { __typename?: 'Org', id: number } | null } }, pathContentMembershipInstances: Array<{ __typename?: 'PathContentMembershipInstance', pathInstance: { __typename?: 'PathInstance', id: string } }> };

export type EmployeeEslReportingFragment = { __typename?: 'Employee', id: number, name: string, phoneNumber?: string | null, language: Language, userType: Types.UserType, locations: Array<{ __typename?: 'Location', id: number, name: string }> };

export type UnsplashImageFragment = { __typename?: 'UnsplashImage', id: string, altDescription?: string | null, urls: { __typename?: 'UnsplashUrls', full: string, regular: string, small: string, thumb: string }, user: { __typename?: 'UnsplashUser', id: string, name: string, links: { __typename?: 'UnsplashUserLinks', html: string } }, links: { __typename?: 'UnsplashLinks', downloadLocation: string } };

export type AutomationLastEditedBy_EmployeeFragment = { __typename?: 'Employee', id: number, name: string, userType: Types.UserType, locations: Array<{ __typename?: 'Location', id: number, name: string }> };

export type AutomationFragment = { __typename?: 'Automation', id: number, type: Types.AutomationType, enabled: boolean, autoReassign: boolean, startDatetime?: string | null, endDatetime?: string | null, newUsersOnly: boolean, updatedAt: string, userSelection: { __typename?: 'UserSelection', id: number, allLocations: boolean, allTrainees: boolean, allManagers: boolean, allAdmins: boolean, daysAfterHire?: number | null, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number, user: { __typename?: 'Employee', id: number, name: string } }>, locationMemberships: Array<{ __typename?: 'UserSelectionLocation', id: number, location: { __typename?: 'Location', id: number, name: string } }>, roleMemberships: Array<{ __typename?: 'UserSelectionRole', id: number, role: { __typename?: 'Role', id: number, name: string } }>, locationGroupMemberships: Array<{ __typename?: 'UserSelectionLocationGroup', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }>, roleGroupMemberships: Array<{ __typename?: 'UserSelectionRoleGroup', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }> }, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, course?: { __typename?: 'Course', id: number } | null, path?: { __typename?: 'Path', id: number } | null, trainingResource?: { __typename?: 'TrainingResource', id: string } | null }, autoReassignInterval?: { __typename?: 'AutoReassignInterval', unit: Types.AutoReassignIntervalUnit, count: number, sourceDateType: Types.AutoReassignIntervalSourceDateType } | null, lastEditedBy?: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType, locations: Array<{ __typename?: 'Location', id: number, name: string }> } | null };

export type PathFragment = { __typename?: 'Path', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, createdAt: string, lastEditedAt?: string | null, openedAt?: string | null, archivedAt?: string | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, createdBy?: { __typename?: 'Employee', id: number, name: string } | null, lastEditedBy?: { __typename?: 'Employee', id: number, name: string } | null }, draftVersion: { __typename?: 'PathVersion', id: string } };

export type SkillThinFragment = { __typename?: 'Skill', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } };

export type SkillThinnestFragment = { __typename?: 'Skill', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } };

export type SkillFragment = { __typename?: 'Skill', id: number, verificationCount: number, libraryItem: { __typename?: 'LibraryItem', id: string, createdAt: string, lastEditedAt?: string | null, openedAt?: string | null, archivedAt?: string | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, createdBy?: { __typename?: 'Employee', id: number, name: string } | null, lastEditedBy?: { __typename?: 'Employee', id: number, name: string } | null, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } };

export type RichTextDocumentFragment = { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } };

export type WorkflowNodeFragment = { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null };

export type WorkflowConnectionFragment = { __typename?: 'WorkflowConnection', id: string, workflowNode?: { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null } | null };

export type ConvertMediaToRichTextDocumentWorkflowFragment = { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, workflow?: { __typename?: 'WorkflowConnection', id: string, workflowNode?: { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null } | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null };

export type TrainingResourceVersionFragment = { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, richTextDocument?: { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, subtitleTracks: Array<{ __typename?: 'SubtitleTrack', id: string, language: Language, subtitleSegments: Array<{ __typename?: 'SubtitleSegment', id: string, index: number, text: string, startTime: number, endTime: number }> }>, mostRecentConvertMediaToRichTextDocumentWorkflow?: { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, workflow?: { __typename?: 'WorkflowConnection', id: string, workflowNode?: { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null } | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null, trainingResource: { __typename?: 'TrainingResource', id: string, lastBuilderActionId?: number | null, draftVersion: { __typename?: 'TrainingResourceVersion', id: string }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null } } };

export type TrainingResourceFragment = { __typename?: 'TrainingResource', id: string, resourceId: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, richTextDocument?: { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, subtitleTracks: Array<{ __typename?: 'SubtitleTrack', id: string, language: Language, subtitleSegments: Array<{ __typename?: 'SubtitleSegment', id: string, index: number, text: string, startTime: number, endTime: number }> }>, mostRecentConvertMediaToRichTextDocumentWorkflow?: { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, workflow?: { __typename?: 'WorkflowConnection', id: string, workflowNode?: { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null } | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null, trainingResource: { __typename?: 'TrainingResource', id: string, lastBuilderActionId?: number | null, draftVersion: { __typename?: 'TrainingResourceVersion', id: string }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null } } } | null, libraryItem: { __typename?: 'LibraryItem', id: string, lastEditedAt?: string | null, openedAt?: string | null, archivedAt?: string | null } };

export type PathInstanceThinFragment = { __typename?: 'PathInstance', id: string, path: { __typename?: 'Path', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } };

export type TrainingResourceInstanceFragment = { __typename?: 'TrainingResourceInstance', id: string, createdAt: string, user: { __typename?: 'Employee', id: number, createdAt: string, name: string, firstName: string, lastName: string, email?: string | null, phoneNumber?: string | null, language: Language, hasUsedApp: boolean, deactivatedAt?: string | null, deactivatedReason?: Types.DeactivationReason | null, userType: Types.UserType, lastActivityAt?: string | null, locations: Array<{ __typename?: 'Location', id: number, name: string }>, roles: Array<{ __typename?: 'Role', id: number, name: string }>, deactivatedBy?: { __typename?: 'Employee', id: number, name: string } | null, hrisEmployee?: { __typename?: 'HrisEmployee', id: number, remoteHrisId: string, firstName: string, lastName: string, startDate?: string | null } | null }, trainingResource: { __typename?: 'TrainingResource', id: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, richTextDocument?: { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, subtitleTracks: Array<{ __typename?: 'SubtitleTrack', id: string, language: Language, subtitleSegments: Array<{ __typename?: 'SubtitleSegment', id: string, index: number, text: string, startTime: number, endTime: number }> }>, mostRecentConvertMediaToRichTextDocumentWorkflow?: { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, workflow?: { __typename?: 'WorkflowConnection', id: string, workflowNode?: { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null } | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null, trainingResource: { __typename?: 'TrainingResource', id: string, lastBuilderActionId?: number | null, draftVersion: { __typename?: 'TrainingResourceVersion', id: string }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null } } } | null }, pathContentMembershipInstances: Array<{ __typename?: 'PathContentMembershipInstance', pathInstance: { __typename?: 'PathInstance', id: string, path: { __typename?: 'Path', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } } }> };

export type NotificationFragment = { __typename?: 'InProductNotification', id: string, readAt?: string | null, type: Types.NotificationType, createdAt: string, message?: string | null, comment?: { __typename?: 'Comment', id: string, text: string, createdBy: { __typename?: 'Employee', id: number, name: string }, thread: { __typename?: 'CommentThread', id: string, prompt?: { __typename?: 'Prompt', uuid: string } | null } } | null, course?: { __typename?: 'Course', id: number, draftVersion: { __typename?: 'CourseVersion', id: number }, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } | null, path?: { __typename?: 'Path', id: number, draftVersion: { __typename?: 'PathVersion', id: string }, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } | null };

export type ContentTagMembershipFragment = { __typename?: 'ContentTagMembership', tagId: string, libraryItemId: string };

export type LocationMemberFragment = { __typename?: 'Employee', id: number, name: string, userType: Types.UserType, roles: Array<{ __typename?: 'Role', id: number, name: string }> };

export type RoleMemberFragment = { __typename?: 'Employee', id: number, name: string, userType: Types.UserType, locations: Array<{ __typename?: 'Location', id: number, name: string }> };

export type AutomationLibraryItemFragment = { __typename?: 'LibraryItem', id: string, dueDate?: string | null, dueDateDays?: number | null, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, name: { __typename?: 'TranslationSet', en: string }, assignmentAutomation?: { __typename?: 'Automation', id: number, type: Types.AutomationType, enabled: boolean, autoReassign: boolean, startDatetime?: string | null, endDatetime?: string | null, newUsersOnly: boolean, updatedAt: string, userSelection: { __typename?: 'UserSelection', id: number, allLocations: boolean, allTrainees: boolean, allManagers: boolean, allAdmins: boolean, daysAfterHire?: number | null, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number, user: { __typename?: 'Employee', id: number, name: string } }>, locationMemberships: Array<{ __typename?: 'UserSelectionLocation', id: number, location: { __typename?: 'Location', id: number, name: string } }>, roleMemberships: Array<{ __typename?: 'UserSelectionRole', id: number, role: { __typename?: 'Role', id: number, name: string } }>, locationGroupMemberships: Array<{ __typename?: 'UserSelectionLocationGroup', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }>, roleGroupMemberships: Array<{ __typename?: 'UserSelectionRoleGroup', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }> }, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, course?: { __typename?: 'Course', id: number } | null, path?: { __typename?: 'Path', id: number } | null, trainingResource?: { __typename?: 'TrainingResource', id: string } | null }, autoReassignInterval?: { __typename?: 'AutoReassignInterval', unit: Types.AutoReassignIntervalUnit, count: number, sourceDateType: Types.AutoReassignIntervalSourceDateType } | null, lastEditedBy?: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType, locations: Array<{ __typename?: 'Location', id: number, name: string }> } | null } | null, accessAutomation?: { __typename?: 'Automation', id: number, type: Types.AutomationType, enabled: boolean, autoReassign: boolean, startDatetime?: string | null, endDatetime?: string | null, newUsersOnly: boolean, updatedAt: string, userSelection: { __typename?: 'UserSelection', id: number, allLocations: boolean, allTrainees: boolean, allManagers: boolean, allAdmins: boolean, daysAfterHire?: number | null, userMemberships: Array<{ __typename?: 'UserSelectionUser', id: number, user: { __typename?: 'Employee', id: number, name: string } }>, locationMemberships: Array<{ __typename?: 'UserSelectionLocation', id: number, location: { __typename?: 'Location', id: number, name: string } }>, roleMemberships: Array<{ __typename?: 'UserSelectionRole', id: number, role: { __typename?: 'Role', id: number, name: string } }>, locationGroupMemberships: Array<{ __typename?: 'UserSelectionLocationGroup', id: string, locationGroup: { __typename?: 'LocationGroup', id: string, name: string, type: Types.LocationGroupType } }>, roleGroupMemberships: Array<{ __typename?: 'UserSelectionRoleGroup', id: string, roleGroup: { __typename?: 'RoleGroup', id: string, name: string } }> }, libraryItem: { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, course?: { __typename?: 'Course', id: number } | null, path?: { __typename?: 'Path', id: number } | null, trainingResource?: { __typename?: 'TrainingResource', id: string } | null }, autoReassignInterval?: { __typename?: 'AutoReassignInterval', unit: Types.AutoReassignIntervalUnit, count: number, sourceDateType: Types.AutoReassignIntervalSourceDateType } | null, lastEditedBy?: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType, locations: Array<{ __typename?: 'Location', id: number, name: string }> } | null } | null, sharingPermissions: { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> } };

export type EmployeeSharedFragment = { __typename?: 'Employee', id: number, name: string, userType: Types.UserType };

export type UserSharingPermissionFragment = { __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } };

export type ContentSharingPermissionFragment = { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number, name: string, userType: Types.UserType } }> };

export type AiGenerateModuleRequestFragment = { __typename?: 'AIGenerateModuleRequest', id: string, generationStartedAt?: string | null, generationCompletedAt?: string | null, generationErroredAt?: string | null };

export type ContentQrCodeFragment = { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string };

export type PathAssignmentTable_AssignmentFragment = { __typename?: 'Assignment', id: string, createdAt: string, firstAssignedAt?: string | null, currentInstanceLastAssignedAt?: string | null, currentInstanceCompletedAt?: string | null, status: AssignmentStatus, currentInstanceLastAssignedByStr?: string | null, user: { __typename?: 'Employee', id: number, name: string, firstName: string, lastName: string, locations: Array<{ __typename?: 'Location', id: number, name: string }>, roles: Array<{ __typename?: 'Role', id: number, name: string }>, hrisEmployee?: { __typename?: 'HrisEmployee', id: number, startDate?: string | null } | null }, pathInstances: Array<{ __typename?: 'PathInstance', id: string, startedAt?: string | null, completedAt?: string | null, dueDate?: string | null, status: AttemptStatus, certificateUrl?: string | null }>, currentPathInstance?: { __typename?: 'PathInstance', id: string, createdAt: string, pathVersion?: { __typename?: 'PathVersion', id: string, metadata: { __typename?: 'VersionMetadata', publishedAt?: string | null } } | null } | null };

export const MyTranslationSetFragmentDoc = gql`
    fragment MyTranslationSet on TranslationSet {
  uuid
  myTranslation
}
    `;
export const TranslationOverrideFragmentDoc = gql`
    fragment TranslationOverride on TranslationOverride {
  id
  text
  sourceText
  language
}
    `;
export const EnglishOnlyTranslationSetFragmentDoc = gql`
    fragment EnglishOnlyTranslationSet on TranslationSet {
  uuid
  en
  translationOverrides {
    ...TranslationOverride
  }
}
    ${TranslationOverrideFragmentDoc}`;
export const ImageUrlsFragmentDoc = gql`
    fragment ImageUrls on ImageUrls {
  id
  original
  wide
  medium
  thumb
}
    `;
export const EnglishOnlyMediaFragmentDoc = gql`
    fragment EnglishOnlyMedia on Media {
  id
  mediaUrls {
    ...EnglishOnlyTranslationSet
  }
  imageUrls {
    ...ImageUrls
  }
  unoptimizedUrl
}
    ${EnglishOnlyTranslationSetFragmentDoc}
${ImageUrlsFragmentDoc}`;
export const TranslationSetFragmentDoc = gql`
    fragment TranslationSet on TranslationSet {
  uuid
  en
  translationsDisabled
  translationOverrides {
    ...TranslationOverride
  }
}
    ${TranslationOverrideFragmentDoc}`;
export const CourseThinNoJoinsFragmentDoc = gql`
    fragment CourseThinNoJoins on Course {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    publishState
  }
}
    ${TranslationSetFragmentDoc}`;
export const LessonFragmentDoc = gql`
    fragment Lesson on Lesson {
  name
}
    `;
export const CourseFragmentDoc = gql`
    fragment Course on Course {
  id
  lessonCount
  topic {
    id
    iconUrl
    displayName
    color
  }
  publishedAt
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    createdBy {
      id
      name
    }
  }
}
    ${TranslationSetFragmentDoc}`;
export const CourseInfoFragmentDoc = gql`
    fragment CourseInfo on Course {
  id
  lessonCount
  publishedAt
  topic {
    id
    iconUrl
    displayName
    color
  }
  libraryItem {
    id
    openedAt
    publishState
    createdBy {
      id
      name
    }
    archivedAt
    name {
      ...TranslationSet
    }
    lastEditedBy {
      id
      name
    }
    lastEditedAt
  }
}
    ${TranslationSetFragmentDoc}`;
export const CourseInstanceFragmentDoc = gql`
    fragment CourseInstance on CourseInstance {
  id
  startedAt
  dueDate
  completedAt
  percentComplete
  track
  certificateUrl
  course {
    id
    libraryItem {
      id
      name {
        ...TranslationSet
      }
    }
  }
}
    ${TranslationSetFragmentDoc}`;
export const LocationGroupMemberFragmentDoc = gql`
    fragment LocationGroupMember on Employee {
  id
  name
  locations {
    id
    name
  }
  roles {
    id
    name
  }
}
    `;
export const EmployeeThinFragmentDoc = gql`
    fragment EmployeeThin on Employee {
  id
  name
  phoneNumber
  language
  userType
}
    `;
export const BlastSentRecordFragmentDoc = gql`
    fragment BlastSentRecord on BlastSentRecord {
  id
  recipient {
    ...EmployeeThin
  }
  firstReadAt
  blastNotifications {
    sentAt
  }
  messageReaction
}
    ${EmployeeThinFragmentDoc}`;
export const MessageBlastThinFragmentDoc = gql`
    fragment MessageBlastThin on MessageBlast {
  id
  createdAt
  sendAt
  sentAt
  messageText {
    uuid
    en
  }
  recipientCount
  readCount
  sentBy {
    name
    id
  }
  subject {
    uuid
    en
  }
  fromOrg
  fromOpus
  draft
}
    `;
export const CourseTopicFragmentDoc = gql`
    fragment CourseTopic on Topic {
  id
  displayName
  iconUrl
  color
}
    `;
export const CourseThinFragmentDoc = gql`
    fragment CourseThin on Course {
  id
  topic {
    ...CourseTopic
  }
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    org {
      id
    }
    publishState
  }
}
    ${CourseTopicFragmentDoc}
${TranslationSetFragmentDoc}`;
export const CourseInstanceCompleteFragmentDoc = gql`
    fragment CourseInstanceComplete on CourseInstance {
  id
  track
  percentComplete
  startedAt
  completedAt
  accuracy
  certificateUrl
  course {
    enableCertificate
    passingAccuracyThreshold
    ...CourseThin
  }
  pathContentMembershipInstances {
    pathInstance {
      id
    }
  }
  dueDate
}
    ${CourseThinFragmentDoc}`;
export const EmployeeEslReportingFragmentDoc = gql`
    fragment EmployeeEslReporting on Employee {
  ...EmployeeThin
  locations {
    id
    name
  }
}
    ${EmployeeThinFragmentDoc}`;
export const UnsplashImageFragmentDoc = gql`
    fragment UnsplashImage on UnsplashImage {
  id
  altDescription
  urls {
    full
    regular
    small
    thumb
  }
  user {
    id
    name
    links {
      html
    }
  }
  links {
    downloadLocation
  }
}
    `;
export const PathFragmentDoc = gql`
    fragment Path on Path {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    createdBy {
      id
      name
    }
    createdAt
    lastEditedAt
    openedAt
    archivedAt
    lastEditedBy {
      id
      name
    }
  }
  draftVersion {
    id
  }
}
    ${TranslationSetFragmentDoc}`;
export const CoverImageFragmentDoc = gql`
    fragment CoverImage on CoverImage {
  id
  emojiIcon
  background
  imageUrls {
    ...ImageUrls
  }
}
    ${ImageUrlsFragmentDoc}`;
export const SkillThinFragmentDoc = gql`
    fragment SkillThin on Skill {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    coverImage {
      ...CoverImage
    }
    description {
      ...TranslationSet
    }
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const SkillThinnestFragmentDoc = gql`
    fragment SkillThinnest on Skill {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    coverImage {
      ...CoverImage
    }
    description {
      ...TranslationSet
    }
  }
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const SkillFragmentDoc = gql`
    fragment Skill on Skill {
  id
  libraryItem {
    id
    name {
      ...TranslationSet
    }
    coverImage {
      ...CoverImage
    }
    createdAt
    createdBy {
      id
      name
    }
    lastEditedAt
    lastEditedBy {
      id
      name
    }
    openedAt
    archivedAt
    description {
      ...TranslationSet
    }
  }
  verificationCount
}
    ${TranslationSetFragmentDoc}
${CoverImageFragmentDoc}`;
export const RichTextDocumentFragmentDoc = gql`
    fragment RichTextDocument on RichTextDocument {
  id
  content {
    ...TranslationSet
  }
}
    ${TranslationSetFragmentDoc}`;
export const MediaFragmentDoc = gql`
    fragment Media on Media {
  id
  mediaUrls {
    ...TranslationSet
  }
  imageUrls {
    ...ImageUrls
  }
  loopVideo
  hideVideoControls
  unoptimizedUrl
  createdAt
  updatedAt
  thumbnailImageUrl
  trainingResourceVersions {
    id
    trainingResource {
      id
      libraryItem {
        id
        name {
          ...TranslationSet
        }
      }
    }
  }
}
    ${TranslationSetFragmentDoc}
${ImageUrlsFragmentDoc}`;
export const WorkflowNodeFragmentDoc = gql`
    fragment WorkflowNode on WorkflowNode {
  id
  failedAt
  succeededAt
}
    `;
export const WorkflowConnectionFragmentDoc = gql`
    fragment WorkflowConnection on WorkflowConnection {
  id
  workflowNode {
    ...WorkflowNode
  }
}
    ${WorkflowNodeFragmentDoc}`;
export const ConvertMediaToRichTextDocumentWorkflowFragmentDoc = gql`
    fragment ConvertMediaToRichTextDocumentWorkflow on ConvertMediaToRichTextDocumentWorkflow {
  id
  workflow {
    ...WorkflowConnection
  }
  richTextDocuments {
    id
  }
}
    ${WorkflowConnectionFragmentDoc}`;
export const ContentQrCodeFragmentDoc = gql`
    fragment ContentQRCode on ContentQRCode {
  id
  includeLogo
  includeTitle
  isActive
  imageUrl
}
    `;
export const TrainingResourceVersionFragmentDoc = gql`
    fragment TrainingResourceVersion on TrainingResourceVersion {
  id
  type
  richTextDocument {
    ...RichTextDocument
  }
  media {
    ...Media
    subtitleTracks {
      id
      language
      subtitleSegments {
        id
        index
        text
        startTime
        endTime
      }
    }
    mostRecentConvertMediaToRichTextDocumentWorkflow {
      ...ConvertMediaToRichTextDocumentWorkflow
    }
  }
  trainingResource {
    draftVersion {
      id
    }
    publishedVersion {
      id
    }
    id
    lastBuilderActionId
    libraryItem {
      id
      publishState
      name {
        ...TranslationSet
      }
      description {
        ...TranslationSet
      }
      qrCode {
        ...ContentQRCode
      }
    }
  }
}
    ${RichTextDocumentFragmentDoc}
${MediaFragmentDoc}
${ConvertMediaToRichTextDocumentWorkflowFragmentDoc}
${TranslationSetFragmentDoc}
${ContentQrCodeFragmentDoc}`;
export const TrainingResourceFragmentDoc = gql`
    fragment TrainingResource on TrainingResource {
  id
  resourceId: id
  publishedVersion {
    ...TrainingResourceVersion
  }
  libraryItem {
    id
    lastEditedAt
    openedAt
    archivedAt
  }
}
    ${TrainingResourceVersionFragmentDoc}`;
export const EmployeeListItemFragmentDoc = gql`
    fragment EmployeeListItem on Employee {
  id
  createdAt
  name
  firstName
  lastName
  email
  locations {
    id
    name
  }
  roles {
    id
    name
  }
  phoneNumber
  language
  hasUsedApp
  deactivatedAt
  deactivatedBy {
    id
    name
  }
  deactivatedReason
  hrisEmployee {
    id
    remoteHrisId
    firstName
    lastName
    startDate
  }
  userType
  lastActivityAt
}
    `;
export const PathInstanceThinFragmentDoc = gql`
    fragment PathInstanceThin on PathInstance {
  id
  path {
    id
    libraryItem {
      id
      name {
        ...TranslationSet
      }
    }
  }
}
    ${TranslationSetFragmentDoc}`;
export const TrainingResourceInstanceFragmentDoc = gql`
    fragment TrainingResourceInstance on TrainingResourceInstance {
  id
  createdAt
  user {
    ...EmployeeListItem
  }
  trainingResource {
    id
    publishedVersion {
      ...TrainingResourceVersion
    }
  }
  pathContentMembershipInstances {
    pathInstance {
      ...PathInstanceThin
    }
  }
}
    ${EmployeeListItemFragmentDoc}
${TrainingResourceVersionFragmentDoc}
${PathInstanceThinFragmentDoc}`;
export const NotificationFragmentDoc = gql`
    fragment Notification on InProductNotification {
  id
  readAt
  type
  createdAt
  comment {
    id
    text
    createdBy {
      id
      name
    }
    thread {
      id
      prompt {
        uuid
      }
    }
  }
  course {
    id
    draftVersion {
      id
    }
    libraryItem {
      id
      name {
        ...TranslationSet
      }
    }
  }
  path {
    id
    draftVersion {
      id
    }
    libraryItem {
      id
      name {
        ...TranslationSet
      }
    }
  }
  message
}
    ${TranslationSetFragmentDoc}`;
export const ContentTagMembershipFragmentDoc = gql`
    fragment ContentTagMembership on ContentTagMembership {
  tagId
  libraryItemId
}
    `;
export const LocationMemberFragmentDoc = gql`
    fragment LocationMember on Employee {
  id
  name
  userType
  roles {
    id
    name
  }
}
    `;
export const RoleMemberFragmentDoc = gql`
    fragment RoleMember on Employee {
  id
  name
  userType
  locations {
    id
    name
  }
}
    `;
export const UserSelectionFragmentDoc = gql`
    fragment UserSelection on UserSelection {
  id
  allLocations
  allTrainees
  allManagers
  allAdmins
  daysAfterHire
  userMemberships {
    id
    user {
      id
      name
    }
  }
  locationMemberships {
    id
    location {
      id
      name
    }
  }
  roleMemberships {
    id
    role {
      id
      name
    }
  }
  locationGroupMemberships {
    id
    locationGroup {
      id
      name
      type
    }
  }
  roleGroupMemberships {
    id
    roleGroup {
      id
      name
    }
  }
}
    `;
export const AutomationLastEditedBy_EmployeeFragmentDoc = gql`
    fragment AutomationLastEditedBy_Employee on Employee {
  id
  name
  userType
  locations {
    id
    name
  }
}
    `;
export const AutomationFragmentDoc = gql`
    fragment Automation on Automation {
  id
  type
  enabled
  userSelection {
    ...UserSelection
  }
  libraryItem {
    id
    course {
      id
    }
    path {
      id
    }
    trainingResource {
      id
    }
    type
  }
  autoReassign
  autoReassignInterval {
    unit
    count
    sourceDateType
  }
  startDatetime
  endDatetime
  newUsersOnly
  updatedAt
  lastEditedBy {
    ...AutomationLastEditedBy_Employee
  }
}
    ${UserSelectionFragmentDoc}
${AutomationLastEditedBy_EmployeeFragmentDoc}`;
export const EmployeeSharedFragmentDoc = gql`
    fragment EmployeeShared on Employee {
  id
  name
  userType
}
    `;
export const UserSharingPermissionFragmentDoc = gql`
    fragment UserSharingPermission on UserSharingPermission {
  id
  user {
    ...EmployeeShared
  }
  permission
}
    ${EmployeeSharedFragmentDoc}`;
export const ContentSharingPermissionFragmentDoc = gql`
    fragment ContentSharingPermission on ContentSharingPermission {
  id
  allAdmins
  allManagers
  individuals {
    ...UserSharingPermission
  }
}
    ${UserSharingPermissionFragmentDoc}`;
export const AutomationLibraryItemFragmentDoc = gql`
    fragment AutomationLibraryItem on LibraryItem {
  id
  description {
    ...TranslationSet
  }
  name {
    en
  }
  dueDate
  dueDateDays
  assignmentAutomation {
    ...Automation
  }
  accessAutomation {
    ...Automation
  }
  sharingPermissions {
    ...ContentSharingPermission
  }
}
    ${TranslationSetFragmentDoc}
${AutomationFragmentDoc}
${ContentSharingPermissionFragmentDoc}`;
export const AiGenerateModuleRequestFragmentDoc = gql`
    fragment AiGenerateModuleRequest on AIGenerateModuleRequest {
  id
  generationStartedAt
  generationCompletedAt
  generationErroredAt
}
    `;
export const PathAssignmentTable_AssignmentFragmentDoc = gql`
    fragment PathAssignmentTable_Assignment on Assignment {
  id
  createdAt
  firstAssignedAt
  currentInstanceLastAssignedAt
  currentInstanceCompletedAt
  status
  currentInstanceLastAssignedByStr
  user {
    id
    name
    firstName
    lastName
    locations {
      id
      name
    }
    roles {
      id
      name
    }
    hrisEmployee {
      id
      startDate
    }
  }
  pathInstances {
    id
    startedAt
    completedAt
    dueDate
    status
    certificateUrl
  }
  currentPathInstance {
    id
    createdAt
    pathVersion {
      id
      metadata {
        publishedAt
      }
    }
  }
}
    `;